<div 
    class="view-annotate"
    [class.view-annotate--exporting]="exporting"
    [class.view-annotate--cursor-paint]="(annotateMode$ | async) === whiteboardAnnotateMode.Paint"
    [class.view-annotate--cursor-erase]="(annotateMode$ | async) === whiteboardAnnotateMode.Erase"
    [class.view-annotate--cursor-text]="(annotateMode$ | async) === whiteboardAnnotateMode.Text"
    #annotateWrapper>

    <!-- labels -->
    <app-view-annotate-label 
        class="view-annotate__label"
        [class.view-annotate__label--clickthrough]="(annotateMode$ | async) !== whiteboardAnnotateMode.Text"
        *ngFor="let label of labels;"
        [exporting]="exporting"
        [id]="label.id"
        [initialPos]="label.pos" 
        [color]="label.color" 
        [size]="label.size"
        (labelActive)=handleLabelActive($event)
        (labelEmpty)=handleLabelEmpty($event)>
    </app-view-annotate-label>

    <!-- Drawing Canvas -->
    <canvas class="view-annotate__canvas" data-test="drawCanvas" #drawCanvas></canvas> 

    <!-- Drawing Toolbar -->
    <div class="view-annotate__tools">
        <app-view-annotate-tools
            (clearClick)="handleResetClick()"
            (downloadClick)="handleDownloadClick()"
            (exitClick)="handleExitClick()">
        </app-view-annotate-tools>
    </div>

</div>